module.exports = __webpack_public_path__ + "static/media/sema.26651b24.png";